import React, { useState, useEffect, useContext } from 'react';
import { Accordion, Box, Button } from '@mantine/core';
import { CSVLink } from 'react-csv';
import moment from 'moment';
import { TableExport } from 'tabler-icons-react';
import { axios } from '../../../../utils/axios';
import DemandPlanningTable from './demandPlanningTable/demandPlanning';
import { RfsContext } from '../../../../contexts/RfsContext';
import { AuthContext } from '../../../../contexts/AuthContext';
import { dlstImplPermissions } from '../../../../constants';
import { sCodeStyles } from '../../../../utils/helpers';

export const DemandPlanning = ({ rfsNumber, activeTab }) => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { form } = useContext(RfsContext);
  const { userRole } = useContext(AuthContext);
  const { rfs_type } = form.rfsInformation;
  const [manualClosureLoading, setManualClosureLoading] = useState(false);

  const fetchDemandPlanning = (rfsNumber) => {
    return axios.get(`delisting/demand_planning/fetch/${rfsNumber}`);
  };

  const storeManualClosure = (payload) => {
    return axios.post(`delisting/manual_closure/demand_planning`, payload);
  };

  const permissions = dlstImplPermissions[rfs_type];

  useEffect(() => {
    if (activeTab === 'dp') {
      setLoading(true);
      axios
        .get(`delisting/demand_planning/fetch/${rfsNumber}`)
        .then(
          (res) => {
            const data = res.data.data.map((s) => {
              s.status = s.status === 'Not Stared' ? 'Not Started' : s.status;
              return s;
            });
            setTableData(data);
          },
          (err) => {
            console.log(err);
          },
        )
        .finally(() => setLoading(false));
    }
  }, [rfsNumber, activeTab]);

  const refresh = (rfs_number) => {
    fetchDemandPlanning(rfs_number).then((res) => {
      setTableData(res.data.data);
    });
  };

  const save = (payload, callback) => {
    setManualClosureLoading(true);
    storeManualClosure(payload)
      .then(() => {
        refresh(rfsNumber);
      })
      .finally(() => {
        setManualClosureLoading(false);
        if (callback) callback();
      });
  };

  const getCsvData = () => {
    const data = [];

    [...tableData].forEach((info) => {
      data.push({
        'SKU number': info.int_rfs_scope_selection?.selection_number,
        Description: info.int_rfs_scope_selection?.selection_name,
        Plants: info.int_rfs_dlst_scope_market
          ? info.int_rfs_dlst_scope_market.market_name
          : 'No Markets',
        Status: info.status,
        Action:
          info.status === 'Closed'
            ? info.manually_closed
              ? 'Manually Closed'
              : 'Automatic Closure'
            : 'NA',
        'Step Deadline': moment(info.sla_date).format('DD-MM-YYYY'),
        'Step Finished': info.finished_date
          ? moment(info.finished_date).format('DD-MM-YYYY')
          : 'Not Finished',
      });
    });

    return data;
  };

  return (
    <div>
      <Box sx={sCodeStyles}>SKU CODES</Box>
      <div style={{ marginTop: '1rem' }} className='exportToCsv-container'>
        <CSVLink
          data={getCsvData()}
          className='export-to-csv'
          filename={'Demand Planning_' + moment().format('YYYY-MM-DD HH:mm:ss')}
        >
          <Button
            leftIcon={<TableExport />}
            color='primary'
            style={{
              marginBottom: '1rem',
              background: 'black',
            }}
          >
            Export to CSV
          </Button>
        </CSVLink>
      </div>
      <Accordion style={{ maxWidth: '100vw' }}>
        {Object.keys(form?.selectedScope || {}).map((name) =>
          form?.selectedScope[name].map((item, index) => {
            const accordionKey = `accordion_${index}`;
            const accordion = tableData.filter(
              (s) => s.int_rfs_scope_selection.selection_number === item['selection_number'],
            );
            if (accordion.length > 0)
              return (
                <Accordion.Item key={accordionKey} value={accordionKey}>
                  <Accordion.Control>{`${name.substring(0, 3).toUpperCase()} - ${
                    item['selection_number']
                  } - ${item['selection_name']}`}</Accordion.Control>
                  <Accordion.Panel>
                    <DemandPlanningTable
                      data={tableData.filter((s) => s.int_rfs_scope_selection.id === item.id)}
                      loading={loading}
                      save={save}
                      manualClosureLoading={manualClosureLoading}
                      readOnly={!permissions['demand_planning'].includes(userRole)}
                    />
                  </Accordion.Panel>
                </Accordion.Item>
              );
          }),
        )}
      </Accordion>
    </div>
  );
};
